import React from "react";
import { Container } from "../../components/container/Container";
import SimpleLink from "../../components/link/SimpleLink";

const IconWithLink = ({ src, link }) => {
  return (
    <Container>
      <span>{src}</span>
      <a href={`mailto:${link.trim()}`} className="text-blue-600 underline">
        {link}
      </a>

    </Container>
  );
};

export default IconWithLink;
